import { adminURL } from "../lib/clients";
import cookies from "../utils/cookies";
import { LoggerFactory } from "../utils/loggerFactory";

const log = LoggerFactory("LoginService");

const LoginService = {
  logout() {
    cookies.set("access_token", "", new Date(0));
    localStorage.removeItem("app");
    localStorage.removeItem("mode");
    window.location.reload();
  },

  login() {
    const redirect = new URL(window.location.href);

    if (redirect.hostname === "localhost") {
      redirect.searchParams.set("app", "app_name");
    }

    window.location.assign(`${adminURL}/login?redirect=${redirect}`);
  },

  getAccessToken() {
    return cookies.get("access_token");
  },

  customerData() {
    const accessToken = this.getAccessToken();
    if (!accessToken) {
      this.login();
    }

    try {
      const token = this.getAccessToken().split(".")[1];

      const decodedData = Buffer.from(token, "base64").toString();

      return JSON.parse(decodedData);
    } catch (error) {
      log("customerData").error(
        "error trying to get logged user data {}",
        error,
      );
    }
  },

  getMode: () => {
    return localStorage.getItem("mode") ?? "visitor";
  },
};

export default LoginService;
